<template>
  <div id="app">
    <template v-if="isLoginPage">
      <router-view />
    </template>
    <el-container v-else class="app-shell">
      <el-aside :width="isCollapsed ? '64px' : '230px'" class="sidebar">
        <div class="brand" v-show="!isCollapsed">
          <div class="brand-mark">井</div>
          <div>
            <div class="brand-title">泉井守望者</div>
            <div class="brand-sub">泉井地图管理后台</div>
          </div>
        </div>
        <div class="brand brand-mini" v-show="isCollapsed">
          <div class="brand-mark">井</div>
        </div>
        <el-menu
          :default-active="$route.path"
          router
          :collapse="isCollapsed"
          background-color="#123c2f"
          text-color="#d7eee6"
          active-text-color="#ffffff"
          class="sidebar-menu"
        >
          <el-menu-item index="/dashboard"><i class="el-icon-data-analysis"></i><span slot="title">数据看板</span></el-menu-item>
          <el-menu-item index="/wells"><i class="el-icon-location-outline"></i><span slot="title">泉井管理</span></el-menu-item>
          <el-menu-item index="/claims"><i class="el-icon-user"></i><span slot="title">泉井认领</span></el-menu-item>
          <el-menu-item index="/patrols"><i class="el-icon-map-location"></i><span slot="title">泉井巡护</span></el-menu-item>
          <el-menu-item index="/tasks"><i class="el-icon-s-operation"></i><span slot="title">检测修缮</span></el-menu-item>
          <el-menu-item index="/donations"><i class="el-icon-present"></i><span slot="title">爱心捐赠</span></el-menu-item>
          <el-menu-item index="/test-progress"><i class="el-icon-document"></i><span slot="title">检测进展</span></el-menu-item>
          <el-menu-item index="/repair-progress"><i class="el-icon-s-tools"></i><span slot="title">修缮进展</span></el-menu-item>
          <el-menu-item index="/clues"><i class="el-icon-search"></i><span slot="title">泉井线索</span></el-menu-item>
          <el-menu-item index="/feedbacks"><i class="el-icon-chat-line-round"></i><span slot="title">问题反馈</span></el-menu-item>
          <el-menu-item index="/users"><i class="el-icon-user-solid"></i><span slot="title">用户管理</span></el-menu-item>
          <el-menu-item index="/settings"><i class="el-icon-setting"></i><span slot="title">系统设置</span></el-menu-item>
        </el-menu>
        <div class="sidebar-bottom">
          <div class="collapse-btn" @click="isCollapsed = !isCollapsed">
            <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </div>
        </div>
      </el-aside>
      <el-container class="main-container" :style="{ marginLeft: isCollapsed ? `64px` : `230px` }">
        <el-header class="topbar">
          <div class="topbar-title">{{ $route.meta.title || '泉井管理' }}</div>
          <div class="topbar-right">
            <div class="admin-chip">
              <i class="el-icon-user-solid"></i>
              <span>{{ adminName }}</span>
            </div>
            <el-button
              type="text"
              class="logout-btn"
              icon="el-icon-switch-button"
              @click="handleLogout"
            >退出</el-button>
          </div>
        </el-header>
        <el-main class="main-content">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return { isCollapsed: false }
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    },
    adminName() {
      try {
        const user = JSON.parse(localStorage.getItem('xjb_admin_user') || '{}')
        return user.nickname || user.username || 'admin'
      } catch (e) {
        return 'admin'
      }
    }
  },
  methods: {
    handleLogout() {
      this.$confirm('确认退出登录吗？', '退出确认', {
        confirmButtonText: '确认退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('xjb_admin_logged')
        localStorage.removeItem('xjb_admin_token')
        localStorage.removeItem('xjb_admin_user')
        this.$message.success('已退出登录')
        this.$router.replace('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
* { box-sizing: border-box; }
body { margin: 0; padding: 0; }

#app { min-height: 100vh; }

.app-shell {
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
}

.sidebar {
  background: #123c2f;
  color: #fff;
  display: flex;
  flex-direction: column;
  transition: width 0.3s;
  overflow: hidden;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  flex-shrink: 0;
}

.sidebar-menu {
  border-right: none;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-menu::-webkit-scrollbar {
  width: 4px;
}
.sidebar-menu::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,.15);
  border-radius: 2px;
}

.sidebar-bottom {
  flex-shrink: 0;
  border-top: 1px solid rgba(255,255,255,.08);
}

.brand {
  height: 72px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  gap: 12px;
  flex-shrink: 0;
}
.brand-mini { justify-content: center; padding: 0; }
.brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #2eb67d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 22px;
  flex-shrink: 0;
  color: #fff;
}
.brand-title { font-size: 18px; font-weight: 800; color: #fff; }
.brand-sub { font-size: 12px; color: #a8d6c7; margin-top: 3px; }

.main-container {
  flex-direction: column;
  transition: margin-left 0.3s;
  overflow: hidden;
}

.topbar {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 3px 16px rgba(31,45,61,.06);
  position: sticky;
  top: 0;
  z-index: 99;
  flex-shrink: 0;
}
.topbar-title {
  font-weight: 700;
  font-size: 16px;
  color: #1a1a1a;
}
.topbar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.admin-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #eef8f3;
  color: #127a54;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
}
.logout-btn {
  color: #f56c6c !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  padding: 6px 10px !important;
}
.logout-btn:hover {
  color: #e03c3c !important;
}

.main-content {
  overflow-y: auto;
  flex: 1;
  background: #f4f7f5;
}

.el-menu--collapse { width: 64px; }
.collapse-btn {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #a8d6c7;
  font-size: 20px;
  transition: color 0.2s;
  &:hover { color: #fff; }
}

/* 全局页面样式 */
.page {
  padding: 24px;
}
.page-title {
  font-size: 20px;
  font-weight: 800;
  color: #123c2f;
  margin: 0 0 20px;
}
.filter-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px 6px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,.05);
}
.table-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,.05);
}
</style>
